<template>
  <SACModal
    modalClass="plan-builder-action-modal"
    :cardClass="`${actionModalView}-builder`"
    :show="showActionModal"
    :close="close"
  >
    <template
      v-if="actionModalView === 'archive'"
      #content
    >
      <ArchivePlan
        :close="close"
        :submit="() => updatePlanStatus('Archived')"
      />
      <ProcessOverlay
        :show="updatingPlan"
        text="Saving details..."
      />
    </template>
    <template
      v-else-if="actionModalView === 'unarchive'"
      #content
    >
      <UnarchivePlan
        :submit="() => updatePlanStatus('Active')"
        :close="close"
        :partnerPSM="partnerPSM"
        :isSmacAdmin="isSmacAdmin"
      />
      <ProcessOverlay
        :show="updatingPlan"
        text="Saving details..."
      />
    </template>
    <template
      v-else-if="actionModalView === 'delete'"
      #content
    >
      <DeletePlan
        :submit="() => updatePlanStatus('Deleted')"
        :close="close"
        :partnerPSM="partnerPSM"
        :isSmacAdmin="isSmacAdmin"
      />
      <ProcessOverlay
        :show="updatingPlan"
      />
    </template>
    <template
      v-else-if="actionModalView === 'edit-plan-warn'"
      #content
    >
      <EditPlanWarn
        :close="close"
        :submit="() => toggleLocalActionModal(selectedPlan, true, 'edit')"
      />
    </template>
    <template
      v-else-if="actionModalView === 'edit'"
      #content
    >
      <EditPlanBuilder
        :close="close"
        :selectedPlan="selectedPlan"
        :partnerSettings="partnerSettings"
        :partner="partner"
      />
    </template>
    <template
      v-else-if="actionModalView === 'details'"
      #content
    >
      <PlanDetail
        :close="close"
        :plan="selectedPlan"
        :partnerSettings="partnerSettings"
      />
    </template>
  </SACModal>
</template>

<script>
import SACModal from '../../sac/SACModal.vue';
import ProcessOverlay from '../../ProcessOverlay.vue';
import ArchivePlan from './actionModal/ArchivePlan.vue';
import UnarchivePlan from './actionModal/UnarchivePlan.vue';
import DeletePlan from './actionModal/DeletePlan.vue';
import EditPlanBuilder from './actionModal/EditPlanBuilder.vue';
import PlanDetail from './actionModal/PlanDetail.vue';
import EditPlanWarn from './actionModal/EditPlanWarn.vue';

export default {
  name: 'ActionModal',
  components: {
    SACModal,
    ProcessOverlay,
    EditPlanBuilder,
    ArchivePlan,
    UnarchivePlan,
    DeletePlan,
    PlanDetail,
    EditPlanWarn,
  },
  props: {
    actionModalView: String,
    showActionModal: Boolean,
    close: Function,
    updatePlanStatus: Function,
    updatingPlan: Boolean,
    isSmacAdmin: Boolean,
    partnerPSM: Object,
    selectedPlan: Object,
    partnerSettings: Object,
    partner: Object,
    toggleLocalActionModal: Function,
  },
};
</script>

<style lang="scss">

.plan-builder-action-modal {
  position: relative;
  .modal-card {
    width: 500px;
  }

  .delete-builder {
    width: 700px;
  }

  .archive-builder, .unarchive-builder, .edit-plan-warn-builder  {
    width: 700px;
    height: 300px;
  }
  .edit-builder {
    width: 100%!important;
  }
  .details-builder {
    width: 400px;
    height: 500px;
    .ac-body-container {
      overflow-y: auto;
    }
  }
  .ac-card-content {
    display: flex;
    flex-direction: column;
    height: 100%;
    animation: fadeIn 0.5s ease;
    position: relative;
    .ac-body-container {
      flex: 1;
      padding: 31px 24px 26px 24px;
      display: flex;
      flex-direction: column;
      align-items: center;
      .ac-close-container {
        width: 100%;
        display: flex;
        align-items: flex-end;
        justify-content: flex-end;
        .ac-close-btn {
          width: 24px;
          height: 24px;
          border-radius: 50%;
          border: 2px solid $NAVY100;
          display: flex;
          align-items: center;
          justify-content: center;
          img {
            width: 50%;
            object-fit: contain;
          }
        }
      }
      .ac-info-logo {
        width: 25px;
        object-fit: contain;
        margin-bottom: 4px;
      }
      .ac-header {
        font-size: 1.5em;
        color: $NAVY100;
        font-weight: 500;
        margin-bottom: 32px;
        text-align: center;
        line-height: 1.2;
        width: 70%;
      }
      .ac-body {
        font-size: 1.25em;
        color: $N90;
        text-align: center;
      }
      .ac-button {
        padding: 6px 9px 5px;
        font-size: 0.75em;
        font-weight: 500;
        color: $N90;
        background-color: #CAD7FF;
        border-radius: 3px;
        margin-top: 36px;
        line-height: 1;
        &:first-child {
          margin-right: 10px;
        }
        &.red {
          background-color: $PUNCH !important;
          color: $WHITE !important;
        }
      }
    }
  }
}
</style>
